// /**
// * debounce function
// * Delays the processing of the event
// */
export const debounce = (callback, wait) => {
  let timerId;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
};

export const throttle = (callback, wait) => {
  let inThrottle;
  return (...args) => {
    if (!inThrottle) {
      callback(...args);
      inThrottle = true;
      setTimeout(() => {
        inThrottle = false;
      }, wait);
    }
  };
};
// /**
// * Checks if an element is focusable
// *
// * @param {Object} el - HTML element you want to check if it's focusable
// */
export const isFocusable = el => {
  if (
    el.tabIndex > 0 ||
    (el.tabIndex === 0 && el.getAttribute('tabIndex') !== null)
  ) {
    return true;
  }

  if (el.disabled) {
    return false;
  }

  /* eslint-disable indent */
  switch (el.nodeName) {
    case 'A':
      return !!el.href && el.rel !== 'ignore';
    case 'INPUT':
      return el.type !== 'hidden' && el.type !== 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
  /* eslint-enable indent */
};

// /**
// * Key code list object
// */
export const keyCode = {
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  PAGEUP: 33,
  PAGEDOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};

// /**
// * Breakpoints list object
// */
export const breakpoints = {
  mobile: 360,
  tablet: 768,
  desktopSmall: 1280,
  desktop: 1440,
  desktopLarge: 1920,
  contentMax: 1920,
  containerMax: 1920
};

// /**
// * Bicentennial Swiper Object
// */

export const bicentennialSwiperConfig = {
  allowTouchMove: false,
  autoHeight: false,
  rewind: true,
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 1000,
  watchOverflow: true,
  watchSlidesProgress: true
}

// /**
// * Convert Unicode characters inside a string to their actual characters
// */

export const convertUnicode = (input) => {
  if (typeof input === 'string') {
    return input.replace(/\\+u([0-9a-fA-F]{4})/g, (a, b) =>
      String.fromCharCode(parseInt(b, 16)))
  }
  return input;
};
